import {
  StoreTradingSchedule,
  CentreTradingSchedule,
  ParsedOpeningHour,
  TradingHour,
  ParsedOpeningHourWithStatus,
} from './types'
import { parseCentreOrLinkedStoreHours } from './parse-centre-or-linked-store-hours'
import { parseOpeningHours } from './parse-opening-hours'
import { stripStatus } from './strip-status'
import { getNonBannerDescription } from './get-non-banner-hours'

function parseUnlinkedStoreHours(
  storeTradingHours: TradingHour[],
  centreTradingHours: TradingHour[],
  centreTimeZone: string
): ParsedOpeningHourWithStatus[] {
  const parsedStoreHours = parseOpeningHours(storeTradingHours, centreTimeZone)
  const parsedCentreHours = parseOpeningHours(
    centreTradingHours,
    centreTimeZone
  )
  return parsedStoreHours.map(storeHour => {
    const centreHour = parsedCentreHours.find(
      centreHr => centreHr.day === storeHour.day
    )

    return {
      ...storeHour,
      text: getNonBannerDescription(storeHour.text, centreHour, '', true),
    }
  })
}

export function parseStoreHours(
  storeTradingSchedule: StoreTradingSchedule,
  centreTradingSchedule: CentreTradingSchedule,
  centreTimeZone: string
): ParsedOpeningHour[] {
  const parsedHoursWithStatus = storeTradingSchedule.isStoreCentreLinked
    ? parseCentreOrLinkedStoreHours(
        storeTradingSchedule.tradingHours,
        centreTimeZone,
        []
      )
    : parseUnlinkedStoreHours(
        storeTradingSchedule.tradingHours,
        centreTradingSchedule.tradingHours,
        centreTimeZone
      )
  return stripStatus(parsedHoursWithStatus)
}
